import React from 'react';
import GoogleMapComponent from '../../GoogleMapComponent';
import StarRating from '../../GoogleMapComponent/RatingComponent'; // Assuming this is a custom component for showing star ratings

function GoogleAddressComponent({
  map,
  i,
  toggleMap,
  DPPstate,
  expandOpenHours,
  handleToggleOpenHours,
  openLinkInNewTab,
  copyPhoneNumber,
  handleOpenGoogleMaps,
}) {
  return (
    <div id="google-map" className={!toggleMap ? 'google-map-control d-block' : 'google-map-control d-none'}>
      {map?.placeDetails && (
        <div className="location-details google-address" data-lat={map.lat || 0} data-lng={map.lng || 0}>
          {DPPstate?.publishHtml ? (
            <GoogleMapComponent withMultiCoordinates locations={[{ lat: map.lat || 0, lng: map.lng || 0, name: map.placeDetails.name }]} showMapImage />
          ) : (
            <GoogleMapComponent
              withMultiCoordinates
              locations={[{ lat: map.lat || 0, lng: map.lng || 0, name: map.placeDetails.name }]}
              // showMapImage
            />
          )}
          <div style={{ marginTop: '20px' }}>
            <div className="map-location-title">
              {map?.placeDetails?.name}
              <div className="icons-data">
                {map.placeDetails.website && (
                  <button aria-label="btn" type="button" onClick={() => openLinkInNewTab(map.placeDetails.website)}>
                    <span className="icon-Website-detail" />
                  </button>
                )}
                {map.placeDetails.formatted_phone_number && (
                  <button aria-label="btn" type="button" onClick={() => copyPhoneNumber(map.placeDetails.formatted_phone_number)}>
                    <span className="icon-Call-detail" />
                  </button>
                )}
                {map.lat && map.lng && (
                  <button aria-label="btn" type="button" onClick={() => handleOpenGoogleMaps({ lat: map.lat || 0, lng: map.lng || 0 })}>
                    <span className="icon-Navigation-detail" />
                  </button>
                )}
              </div>
            </div>
            <p className="location-address">{map?.placeDetails?.formatted_address}</p>
            {map?.placeDetails.rating && (
              <p className="location-rating" style={{ display: 'flex' }}>
                {`(${map?.placeDetails?.rating})`}
                <span style={{ marginRight: '5px' }}>
                  <StarRating rating={map?.placeDetails?.rating} />
                </span>
              </p>
            )}
            <div className="d-flex align-items-center other-detail">
              <p>{map?.placeDetails?.opening_hours?.open_now ? <span className="location-open">Open</span> : <span className="location-close">Close</span>}</p>
              {map?.placeDetails.formatted_phone_number && <p className="ml-auto">{map?.placeDetails.formatted_phone_number || 'N/A'}</p>}
            </div>
            {map?.placeDetails?.opening_hours && (
              <div>
                {map?.placeDetails?.opening_hours?.open_now && (
                  <p>
                    <strong>Opening Hours:</strong>
                    <button aria-label="btn" type="button" className="btn btn-hour" onClick={() => handleToggleOpenHours(i)}>
                      <span
                        id="collapsible-hour"
                        className={`icon-new-down-arrow-icon drop-icon ml-auto f-20 ${expandOpenHours?.includes(i) ? 'rotated' : ''}`}
                      />
                    </button>

                    <ul id="expand-hour" className={expandOpenHours?.includes(i) ? 'opening-hours-ul d-block' : 'd-none'}>
                      {map?.placeDetails?.opening_hours?.weekday_text?.map((text, index) => (
                        <li key={index}>{text}</li>
                      ))}
                    </ul>
                  </p>
                )}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default GoogleAddressComponent;
